import { graphql } from "react-relay";

export const UpdateUserGroupMembersMutation = graphql`
  mutation UpdateUserGroupMembersMutation(
    $input: UpdateUserGroupMembersInput!
  ) {
    updateUserGroupMembers(input: $input) {
      userGroup {
        id
      }
      problems {
        message
      }
    }
  }
`;
